import { JSX } from "react";
import { CustomTable } from "../../../../components";
import { Column } from "../../../../components/customTable/CustomTable";

import { showDateTime } from "../../../../utilities/helper";



interface Props {
  data: any[];
  RevealField: ({
    rowIndex,
    field,
    value,
  }: {
    rowIndex: number;
    field: string;
    value?: string;
  }) => JSX.Element;
}

const SimilarLeadExpand = ({ data, RevealField }: Props) => {
  return (
    <CustomTable
      value={data}
      pagination={false}
      totalRecords={data.length}
      emptyMessage="No duplicate records found"
    >
      <Column header="S.NO" body={(_, index) => index + 1} />
      <Column header="COMPANY" field="companyName" body={(row, index) => (
        <RevealField
          rowIndex={index}
          field="company"
          value={row.companyName}
        />
      )} />
      <Column header="POC" field="pocName" body={(row, index) => (
        <RevealField
          rowIndex={index}
          field="poc"
          value={row.pocName}
        />
      )}
      />
      <Column header="PHONE NUMBER" field="contact" body={(row, index) => (
        <RevealField
          rowIndex={index}
          field="contact"
          value={row.contact}
        />
      )} />
      <Column header="EMAIL" field="email" body={(row, index) => (
        <RevealField
          rowIndex={index}
          field="email"
          value={row.email}
        />
      )} />
      <Column header="COUNTRY" field="countryName"  />

      <Column header="ASSIGNED TO" field="assignedToUser" />
      <Column header="STATUS" field="leadStatus" />
      <Column header="CREATED BY" field="createdBy" />
      <Column header="CREATED AT" body={(row: any) => row.createdAt ? showDateTime(row.createdAt) : "-"} />
    </CustomTable>
  );
};

export default SimilarLeadExpand;